import React from 'react';
import { Link } from 'react-router-dom';

const Dropdown = ({ isOpen, toggle }) => {
  return (
    <div
      className={
        isOpen
          ? 'grid grid-rows-2 text-center items-center bg-octohedz-d'
          : 'hidden'
      }
      onClick={toggle}
    >
        <Link to='/mint' className='p-4 text-xl'>
          Mint
        </Link>
        <Link to='/profile' className='p-4 text-xl'>
          Profile
        </Link>
    </div>
  );
};

export default Dropdown;
